import urls from "web/constants/urls";

import setBenefitGroupTypeParam from "./setBenefitGroupTypeParam";

const getSubscriptionChoiceUrl = (
  configuratorWindowOpen: boolean,
  configuratorWindowOpenUms: boolean
) => {
  switch (true) {
    case configuratorWindowOpen && configuratorWindowOpenUms: {
      return urls.subscriptions;
    }
    case configuratorWindowOpen: {
      return `${
        urls.checkoutSubscriptionConfiguration
      }${setBenefitGroupTypeParam("1")}`;
    }
    case configuratorWindowOpenUms: {
      return `${
        urls.checkoutSubscriptionConfiguration
      }${setBenefitGroupTypeParam("2")}`;
    }
    default: {
      return urls.subscriptions;
    }
  }
};

export default getSubscriptionChoiceUrl;
